import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// PSI 상세 상태(공장>스테이지>품목>인벤토리별 기초/기말재고+생산/소비 내역 크로스탭, `prod-sales-stock-status`의
// 상세(isDetail=true) 변종) — 크로스탭 그리드용. AnalysisController#getPsiDetailData(백엔드는
// factoryplan/analysis/prod-sales-stock-status/detail). 다른 크로스탭 화면과 같은
// { crosstabHeader, chartHeader, data[].pivotData } 형태이되, leaf가 단일 measure가 아니라
// analysisIndicator(기초재고/생산·입고 4종/소비 5종/출하/그룹합계/기말재고) 다수 행이다.
const getPsiDetails = (params) => fpApiUtil.postParams(`${ANALYSIS}/prod-sales-stock-status/detail`, params);

// 같은 엔드포인트의 차트용 호출 — 그리드에서 클릭한 행(plantCd/stageCd/itemCd/inventoryCd)으로
// 드릴다운, useGrouping:true로 그 레벨까지 백엔드가 집계해서 analysisIndicator별 1행씩 내려준다.
// 컬럼 필터(changes)는 1차 미이관이라 항상 빈 객체로 보낸다(fp-report-screen-guide.md §A-6e와 동일 결정).
const getPsiDetailChart = (params, changes) =>
  fpApiUtil.postFields(`${ANALYSIS}/prod-sales-stock-status/detail`, { params, changes });

const fpPsiDetailService = { getPsiDetails, getPsiDetailChart };
export default fpPsiDetailService;
